<template>
    <RegularModal ref="modal">
        <template v-slot:title>
            <h4 class="modal-title">{{ translate("admin_fights_manage.confirm_moving_title") }}</h4>
        </template>

        <template v-slot:body>
            <div class="field">
                <label class="label">{{ translate("admin_fights_manage.target_mat") }}</label>
                <div class="control">
                    <div class="select is-fullwidth">
                        <select v-model="targetMatId">
                            <option disabled value="0">-----</option>
                            <option v-for="mat in targetMats" :value="mat.id" :key="mat.id">{{ mat.name }}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div>
                <div>
                    <Radio name="queueTargetPlace" initial-value="BEGINNING" v-model="queueTargetPlace">
                        {{ translate("admin_fights_manage.move_fights_to_beginning") }}
                    </Radio>
                </div>

                <div>
                    <Radio name="queueTargetPlace" initial-value="END" v-model="queueTargetPlace">
                        {{ translate("admin_fights_manage.move_fights_to_end") }}
                    </Radio>
                </div>
            </div>
        </template>

        <template v-slot:footer>
            <div class="buttons">
                <button @click="close" class="button">
                    {{ translate("common.cancel") }}
                </button>
                <button @click="confirm" class="button is-primary" :disabled="!isValid">
                    {{ translate("common.ok") }}
                </button>
            </div>
        </template>
    </RegularModal>
</template>

<script>
    import translatorMixin from "../Common/translatorMixin";
    import RegularModal from "../Common/RegularModal.vue";
    import Radio from "../Common/Radio.vue";

    export default {
        name: "confirm-fights-move-modal",
        components: {
            Radio,
            RegularModal,
        },
        mixins: [translatorMixin],
        props: ["mats", "sourceMatId"],
        emits: ["moveTargetConfirmed"],
        data() {
            return {
                targetMatId: 0,
                queueTargetPlace: "",
            };
        },
        computed: {
            isValid() {
                return !!this.targetMatId && !!this.queueTargetPlace.length;
            },
            targetMats() {
                return this.mats.filter(mat => {
                    return mat.id !== this.sourceMatId;
                });
            },
        },
        methods: {
            confirm() {
                this.close();
                this.$emit("moveTargetConfirmed", {
                    targetMatId: this.targetMatId,
                    queueTargetPlace: this.queueTargetPlace,
                });
            },
            open() {
                this.targetMatId = 0;
                this.queueTargetPlace = "";
                this.$refs.modal.open();
            },
            close() {
                this.$refs.modal.close();
            },
        },
    };
</script>
